import { isUserLoggedIn } from "@/auth/utils";

export default [
    {
        path: "/contacts",
        name: "contacts",
        component: () => import("@/views/modules/contacts/contacts.vue"),
        meta: {
            contentClass: "module-contacts",
            resource: "contacts",
            action: "read",
        },
        beforeEnter: isUserLoggedIn,
    },
    {
        path: "/contacts/add",
        name: "contacts-add",
        component: () => import("@/views/modules/contacts/contactsAdd.vue"),
        meta: {
            navActiveLink: "contacts",
            resource: "contacts",
            action: "read",
        },
        beforeEnter: isUserLoggedIn,
    },
    {
        path: "/contacts/lists",
        name: "contacts-lists",
        //component: () => import("@/views/modules/contacts/lists/lists.vue"),
        component: () => import("@/views/modules/contacts/contacts.vue"),
        meta: {
            navActiveLink: "contacts",
            resource: "contacts",
            action: "read",
        },
    },
    {
        path: "/contacts/lists/add",
        name: "contacts-lists-add",
        component: () => import("@/views/modules/contacts/lists/listsAdd.vue"),
        meta: {
            navActiveLink: "contacts",
            resource: "contacts",
            action: "read",
        },
    },
    {
        path: "/contacts/lists/:id",
        name: "contacts-lists-edit",
        component: () => import("@/views/modules/contacts/lists/listsEdit.vue"),
        meta: {
            navActiveLink: "contacts",
            resource: "contacts",
            action: "read",
        },
    },
    {
        path: "/contacts/:id",
        name: "contacts-edit",
        component: () => import("@/views/modules/contacts/contactsEdit.vue"),
        meta: {
            navActiveLink: "contacts",
            resource: "contacts",
            action: "read",
        },
        beforeEnter: isUserLoggedIn,
    },
];
